export const AccessSharingTabs = {
  EQUIPMENT_AND_FLEETS: 'equipment-and-fleets',
  SHARED_WITH: 'shared-with',
  PENDING_INVITATIONS: 'pending-invitations',
} as const;
